import { createSelector } from 'reselect';
import { prop, equals } from 'ramda';
import { ERROR_CODES } from '../enums';

export const getError = prop('error');

export const hasTechnicalError = createSelector(getError, prop('display'));

export const getErrorCode = createSelector(getError, prop('errorCode'));

export const getStatusCode = createSelector(getError, prop('statusCode'));

export const getMethod = createSelector(getError, prop('method'));

export const getEvent = createSelector(getError, prop('event'));

export const getErrorMessage = createSelector(getError, prop('errorMessage'));

export const getIsOTPNotValid = createSelector(getErrorCode, equals(ERROR_CODES.OTP_INVALID));

export const getIsUnderGracePeriod = createSelector(getErrorCode, equals(ERROR_CODES.SUBSCRIPTION_UNDER_GRACE_PERIOD));

export const getClaimAlreadyExists = createSelector(getErrorCode, equals(ERROR_CODES.OPENED_CLAIM_ALREADY_EXISTS_GIVEN_THE_PLATE_NUMBER));

export const getConfirmationErrorCallProvider = createSelector(getErrorCode, equals(ERROR_CODES.CONFIRMATION_ERROR_CALL_ASSISTANCE));

export const getEntityNotFound = createSelector(getErrorCode, equals(ERROR_CODES.ENTITY_NOT_FOUND));

export const getVerificationErrorCallProvider = createSelector(getErrorCode, equals(ERROR_CODES.VERIFICATION_MAX_ATTEMPTS_EXCEEDED));
